export default {
  mobile_app_average_order_value: {
    label: 'Durchschnittlicher Bestellwert über App',
  },
  mobile_app_gmv: {
    label: 'Umsatz über App',
  },
  mobile_app_gmv_percentage: {
    label: 'Umsatzanteil über App (%)',
  },
  mobile_app_downloads: {
    label: 'App-Downloads',
  },
  mobile_app_orders_count: {
    label: 'App-Bestellungen',
  },
  name: {
    label: 'Restaurant',
  },
  mobile_app_released_at: {
    label: 'Veröffentlichungsdatum',
  },
  title: 'Restaurant-Verzeichnis',
};
